import React from "react";
import moment from "moment-timezone";

import Icon from "~/src/components/icon";
import {
  GridCardWrapper,
  Header,
  Time,
  IconWrapper,
} from "./unavailable-grid-card.styles";

const UnavailableGridCard = ({
  unavailability: { startsAt, endsAt, reason },
  onClick,
}) => {
  const reasonLabels = {
    unwell: "Feeling unwell",
    personal: "Personal reason",
    holiday: "On holiday",
    ratherNotSay: "Rather not say",
    workStudy: "Work / study commitments",
  };

  return (
    <GridCardWrapper
      onClick={onClick}
      title={reasonLabels[reason] || undefined}
    >
      <Header>Unavailable</Header>
      <Time>
        {startsAt ? moment(startsAt).format("HH:mm") : ""}
        {"-"}
        {endsAt ? moment(endsAt).format("HH:mm") : ""}
      </Time>
      <IconWrapper>
        <Icon
          name={Icon.names.PLUS}
          color={Icon.colors.SILVER}
          size={Icon.sizes.SMALL}
        />
      </IconWrapper>
    </GridCardWrapper>
  );
};

export default UnavailableGridCard;
